<div style="height:calc(100vh - 64px); overflow-y: auto;">
  <div class="container-fluid">
    <br/><br/>
    <div class="row justify-content-center">
      <div class="col-12 col-md-5">
        <div style="display: flex;">
          <mat-icon color="primary" class="rm-header-icon">corporate_fare</mat-icon>&nbsp;
          <span class="rm-title rm-title-3">Business Units</span>
        </div>
        <span class="rm-title rm-title-6 rm-lighter">These are all of the business units you have access to:</span>
      </div>
      <div class="col-md-6 d-none d-md-block text-end ">
        <button mat-raised-button
                color="primary"
                (click)="openBusinessUnitModal()"
                title="Create a New Business Unit"
                [hasPermission]="util.Permission.CAN_ADD_BUSINESS_UNITS"
        >
          <mat-icon>group_add</mat-icon>&nbsp;
          Create New Business Unit
        </button>
      </div>
      <div class="col-12 d-flex d-md-none" style="padding-top: 25px;">
        <button mat-raised-button
                color="primary"
                (click)="openBusinessUnitModal()"
                title="Create a New Business Unit"
                [hasPermission]="util.Permission.CAN_ADD_BUSINESS_UNITS"
        >
          <mat-icon>group_add</mat-icon>&nbsp;
          Create New Business Unit
        </button>
      </div>
    </div>
    <!--    table start-->
    <div class="row justify-content-center d-none d-md-flex" style="padding-top: 25px;">
      <div class="col-12 col-md-11">
        <div class="table-container">
          <div class="row table-inner-container">
            <div class="table-inner-inner-container">
              <table mat-table [dataSource]="dataSource" [multiTemplateDataRows]="true" matSort>
                <!-- Search Header -->
                <ng-container matColumnDef="table-name">
                  <th colspan="2" mat-header-cell *matHeaderCellDef>
                    <span style="font-size: large;">Business Units <em *ngIf="selectedBusinessUnitFilterType.length">(filtered)</em></span>
                  </th>
                </ng-container>

                <!-- filter container  -->
                <ng-container matColumnDef="filter-container">
                  <th colspan="2" mat-header-cell *matHeaderCellDef>
                    <mat-form-field>
                      <mat-label>Status Filter</mat-label>
                      <mat-select multiple [(value)]="selectedBusinessUnitFilterType" (selectionChange)="applyTypeFilter($event.value)">
                        <mat-option *ngFor="let type of businessUnitFilterTypes" [value]="type.key">
                          {{ type.value }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </th>
                </ng-container>
                &nbsp;
                <!-- Search Header -->
                <ng-container matColumnDef="search-header">
                  <th colspan="4" mat-header-cell *matHeaderCellDef>
                    <mat-form-field style="width: 100%;">
                      <mat-label>Search by Name</mat-label>
                      <input type="text" matInput (keyup)="applyFilter($event)" #input/>
                      <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                  </th>
                </ng-container>
                <!-- Display Name Column -->
                <ng-container matColumnDef="DisplayName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="displayName"
                      sortActionDescription="Sort by Business Unit"> Business Unit
                  </th>
                  <td mat-cell *matCellDef="let element" style="padding: 5px;">
                    <app-user-card [firstName]="element['displayName']"
                                   [displayName]="element['slug']"
                                   [borderColor]="'transparent'"
                                   [sideColor]="'#ff0000'"
                                   [image]="element['imageUrl']"
                    ></app-user-card>
                  </td>
                </ng-container>

                <!-- Type Column -->
                <ng-container matColumnDef="Type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="businessUnitType"
                      sortActionDescription="Sort by Profile Type"> Profile Type
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element["businessUnitType"]?.toUpperCase() }}
                  </td>
                </ng-container>
                
                <!-- User Column -->
                <ng-container matColumnDef="User">
                  <th mat-header-cell *matHeaderCellDef> Representative</th>
                  <td mat-cell
                      *matCellDef="let element"> {{ (element["representative"]?.["firstName"] || '') + ' ' + (element["representative"]?.["lastName"] || '') }}
                    <br/>
                    {{ element["representative"]?.["email"] || '' }}
                  </td>
                </ng-container>

                <!-- Submissions Column -->
                <ng-container matColumnDef="Submissions">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="submissions"
                      sortActionDescription="Sort by # of Submissions">Submissions
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <span>{{ element.submissionsCount }}</span>
                  </td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="Employees">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="employees"
                      sortActionDescription="Sort by # of Employees">Employees
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <span>{{ element.employeesCount }}</span>
                  </td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="Status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="status"
                      sortActionDescription="Sort by Business Unit Status">BU Status
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span [appStatus]="element.status">{{ element.status }}</span>
                  </td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="Created">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="created"
                      sortActionDescription="Sort by Created Date"> Created
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="date-stacked">
                      <span>{{ element.created | date : 'mediumDate' }}</span>
                      <span>{{ element.created | date : 'shortTime' }}</span>
                    </div>
                  </td>
                </ng-container>
              
                <!-- Actions Column -->
                <ng-container matColumnDef="Actions">
                  <th mat-header-cell *matHeaderCellDef> Actions</th>
                  <td mat-cell *matCellDef="let element">
                    <div style="display: flex;">
                      <button mat-icon-button (click)="viewHistory(element)" title="View History">
                        <mat-icon>history</mat-icon>
                      </button>
                      <button mat-icon-button
                              (click)="viewBusinessUnit(element)"
                              title="View Business Unit"
                              [hasPermission]="util.Permission.CAN_ACCESS_BUSINESS_UNITS"
                      >
                        <mat-icon>east</mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <!-- Row start-->
                <tr mat-header-row *matHeaderRowDef="['table-name', 'filter-container' ,'search-header'];"></tr>
                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true;"></tr>
                <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="7">No data matching the filter.</td>
                </tr>
                <!-- Row end-->
              </table>
            </div>
          </div>
          <mat-paginator style="background-color: white; z-index: 99;" [pageSizeOptions]="[100, 200, 500]"
                         [pageSize]="100"
                         aria-label="Select page of users">
          </mat-paginator>
        </div>
      </div>
    </div>
    <!--    list start-->
    <div class="row justify-content-center d-flex d-md-none" style="padding-bottom: 150px; padding-top: 15px;">
      <div class="col-12">
        <ul style="list-style-type: none; padding: 25px 0 0 0;">
          <li *ngFor="let element of dataSource.data"
              style="margin-bottom: 5px; display: flex; justify-content: space-between;">
            <app-user-card [firstName]="element?.displayName"
                           [displayName]="element?.slug"
                           [borderColor]="'transparent'"
                           [sideColor]="'#ff0000'"
                           [image]="element?.['imageUrl']"
                           [imageShape]="'square'"
            ></app-user-card>
            <div style="display: flex;">
              <button mat-icon-button 
                (click)="viewBusinessUnit(element)"
                title="View Business Unit"
                [hasPermission]="util.Permission.CAN_ACCESS_BUSINESS_UNITS"
              >
                <mat-icon>east</mat-icon>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
